import React from 'react';
import Seo, { SITE } from '../../components/Seo/Seo';
import CyvContactForm from '../../components/ContactForm/CyvContactForm';
import './Contact.css';

// Contact page (#23) — custom CYV form routed through the shared inquiry
// pipeline (submitContact, inquiryKind:'contact') to the admin dashboard +
// sing@coloryourvoice.com. Surface 9 restyles the presentation only — the form
// fields, validation, and submit flow are unchanged.
const Contact24 = () => {
	return (
		<main className='cyv contact-page'>
			<Seo
				title='Contact Color Your Voice | Burnsville, MN'
				description='Questions about voice lessons or summer workshops? Contact Color Your Voice in Burnsville, MN — call or text 952-283-0560, or send a note and we will get right back to you.'
				canonical={`${SITE}/contact`}
			/>

			<div className='contact-wrap'>
				<header className='contact-head'>
					<span className='eyebrow'>Say hello</span>
					<h1 className='brand-heading'>Get in touch</h1>
					<p>
						Questions about lessons, workshops, or anything else? Send us a note
						and we'll get right back to you.
					</p>
				</header>

				<CyvContactForm />

				<p className='contact-callout'>
					Prefer to call or text?
					<a href='tel:9522830560'>952-283-0560</a>
				</p>
			</div>
		</main>
	);
};

export default Contact24;
